import React from "react";

import styles from "./customersimplified.module.scss";

import CustomerSimplifiedDTO from "../dtos/CustomerSimplifiedDTO";

import Card from "features/shared/components/card/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomerAvatar from "./CustomerAvatar";

interface IProps {
  customer: CustomerSimplifiedDTO;
  selectCustomerHandler: (customer: CustomerSimplifiedDTO) => void;
}

const CustomerSelectList: React.FC<IProps> = (props) => { 
  // props destruct
  const { customer } = props;

  // render
  return (
    <Card className={`py-2 px-3 ${styles.customerCard}`}>
      <div className={styles.overlay} onClick={() => props.selectCustomerHandler(customer)}></div>
      <div className="row no-gutters align-items-center">
        <div className="col-auto pr-3">
          <CustomerAvatar customerType={customer.customerType!} size={36} disableShadow />
        </div>
        <div className="col">
          <h6 className="mb-0">
            <span className="d-block d-sm-inline mr-2">{customer.name}</span>
            <span className="badge badge-pill badge-secondary small font-weight-normal">{customer.customerNumber}</span>
          </h6>
          <div className="text-muted">{customer.address}</div>
        </div>
        <div className="col-auto pl-3">
          <span className={styles.selectIcon}>
            <FontAwesomeIcon icon="chevron-right" />
          </span>
        </div>
      </div>
    </Card>
  );
};

export default CustomerSelectList;
